import { Middleware, applyMiddleware, createStore } from "redux";
import { createLogger } from "redux-logger";
import thunk from "redux-thunk";
import promiseMiddleware from "redux-promise-middleware";
import AuthAccountsReducer from "./reducer";

const middlware: Middleware[] = [thunk, promiseMiddleware];

if (process.env.NODE_ENV === "development") {
  middlware.push(createLogger({ collapsed: true }));
}

const store = createStore(AuthAccountsReducer, applyMiddleware(...middlware));

const defaultState = store.getState();

export type State = typeof defaultState;

export default store;
